import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

interface StyleProps {
  hasExtraBanner?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  secondaryHeader: {
    textAlign: 'center',
    fontWeight: 700,
    lineHeight: '18px',
    padding: '14px 0',
    fontSize: '14px',
  },
  secondaryHeaderScrolled: {
    position: 'fixed',
    zIndex: 2000,
    width: 657,
    top: 68,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  primaryHeader: {
    display: 'flex',
    padding: 16,
    height: 95,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    color: theme.palette.common.white,
  },
  primaryHeaderScrolled: {
    top: ({ hasExtraBanner }) => (hasExtraBanner ? 114 : 68),
    gap: 25,
    padding: 0,
    height: 53,
    position: 'fixed',
    alignSelf: 'flex-start',
    width: 657,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      gap: 2,
    },
    zIndex: 10,
    transition: 'all .5s ease-in-out',
  },
  hide: {
    visibility: 'hidden',
  },
}));
